import { RelayPatchCachingServersWebComponent } from './component/RelayPatchCachingServersWebComponent';
import { WEB_COMPONENT_RELAY_PATCH_CACHING_SERVERS } from '../../webcomponents.constants';

export { RelayPatchCachingServersWebComponent };

window.customElements.define(WEB_COMPONENT_RELAY_PATCH_CACHING_SERVERS, RelayPatchCachingServersWebComponent);
